import { StandardEvents } from '@shopify/events';

class ProductCampaign extends HTMLElement {
  request;
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartChange);
    document.addEventListener(StandardEvents.cartDiscountUpdate, this.onCartChange);
    window.addEventListener('pageshow', this.refresh);
    this.addEventListener('click', this.copyCode);
    this.refresh();
  }
  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartChange);
    document.removeEventListener(StandardEvents.cartDiscountUpdate, this.onCartChange);
    window.removeEventListener('pageshow', this.refresh);
    this.request?.abort();
    this.removeEventListener('click', this.copyCode);
    clearTimeout(this.copyTimer);
  }
  copyCode = async (event) => {
    const button = event.target.closest('[data-copy-code]');
    if (!button || !this.contains(button)) return;
    try {
      const field = document.createElement('textarea');
      field.value = button.dataset.copyCode;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
      this.append(field);
      field.select();
      const copied = document.execCommand('copy');
      field.remove();
      button.focus({preventScroll:true});
      if (!copied) await navigator.clipboard.writeText(button.dataset.copyCode);
      button.textContent = 'Kopyalandı';
      clearTimeout(this.copyTimer);
      this.copyTimer = setTimeout(() => {button.textContent = button.dataset.copyCode;}, 2000);
    } catch {
      button.textContent = button.dataset.copyCode;
      button.setAttribute('aria-label', 'Kupon kodu: ' + button.dataset.copyCode);
    }
  };
  onCartChange = (event) => {
    Promise.resolve(event.promise).then(this.refresh).catch(() => {});
  };
  refresh = async () => {
    this.request?.abort();
    this.request = new AbortController();
    try {
      const response = await fetch(this.dataset.cartUrl, {signal:this.request.signal, cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      const applied = (cart.cart_level_discount_applications || []).some(discount =>
        discount.title === '2 ve Üzeri Üründe Sepete %15 İndirim' && discount.total_allocated_amount > 0);
      const state = cart.item_count === 0 ? 'empty' : cart.item_count === 1 ? 'one' : applied ? 'applied' : '';
      this.querySelectorAll('[data-campaign]').forEach(panel => {panel.hidden = panel.dataset.campaign !== state;});
    } catch (error) {
      if (error.name !== 'AbortError') this.querySelectorAll('[data-campaign]').forEach(panel => {panel.hidden = true;});
    }
  };
}
if (!customElements.get('erten-product-campaign')) customElements.define('erten-product-campaign', ProductCampaign);
